import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Die Lieferanten, bei denen man bestellen kann - fuer den Knopf in der
 * Kopfzeile (WareBestellen) und die Leiste unten auf dem Handy (BestellenWahl).
 *
 * Die Liste kommt vom Server, damit ein neuer Shop nur dort eingetragen
 * werden muss. Bis die Antwort da ist (oder wenn sie ausbleibt), steht die
 * Reserve: die zwei Wege, die es immer gibt.
 */
export const LIEFERANTEN_RESERVE = [
  { id: "komet", name: "Komet Shop", scan: true, aktiv: true,
    beschreibung: "Verpackungscode scannen, Menge wählen, bestellen" },
  { id: "implantate", name: "Implantat-Bauteile", scan: false, aktiv: true, gruppe: "implantate",
    beschreibung: "Titanbasen, Scanbodies, Rohlinge - Original oder kompatibel" },
];

export default function useLieferanten() {
  const [lieferanten, setLieferanten] = useState(LIEFERANTEN_RESERVE);
  useEffect(() => {
    api.get("/bestellungen/lieferanten")
      .then((r) => { if (Array.isArray(r.data) && r.data.length) setLieferanten(r.data); })
      .catch(() => {});
  }, []);
  return lieferanten;
}
